import * as React from 'react';
import { FormControl } from '@common/components/form-control';
import cx from 'classnames';

import './input.styles.scss';

export const Input = (props) => {
  const { value, className, placeholder, metadata, onSave, normalizeBeforeSave, moduleName, type = 'text', validate } = props;

  const handleChange = React.useCallback((e) => {
    e.persist();
    
    const { value } = e.target;
    const normalizedValue = normalizeBeforeSave(value);

    onSave({
      value: normalizedValue,
      metadata,
    });
  }, [onSave, normalizeBeforeSave, metadata]);

  const handleBlur = React.useCallback((e) => {
    e.persist();
    const { value } = e.target;
    const normalizedValue = normalizeBeforeSave(value);
    const isValid = validate ? validate(normalizedValue) : true;

    if (!isValid) {
      onSave({
        value: null,
        metadata,
      });
    }
  }, [onSave, normalizeBeforeSave, metadata, validate]);

  return (
    <FormControl
      placeholder={placeholder}
      id={`${moduleName}-input--filter`}
      title={value}
      className={cx('TableInput', className)}
      type={type}
      value={value ?? ''}
      onChange={handleChange}
      onBlur={validate ? handleBlur : undefined}
    />
  );
};

Input.defaultProps = {
  defaultValue: '',
  normalizeBeforeSave: (value) => value
};